import { useIsAutorizedUser } from 'store/features/auth/selectors';
import { useUserPermissions } from 'store/features/auth';
import { useActiveModals } from 'entities/application';
import { useIsClient } from 'store/features/auth/selectors/user';

export const useShowDriverLocationsButton = () => {
  const permissions = useUserPermissions();
  const isAutorizedUser = useIsAutorizedUser();
  const isClient = useIsClient();
  const { showRoute } = useActiveModals();

  return !(!isAutorizedUser || permissions.mapFavouriteHidden || showRoute || (isAutorizedUser && !isClient));
};